<template>
  <!-- APP CONTAINER -->
  <div class="app">
<!-- HERO APP GRANDE -->
<section class="hero-app">
  <div class="hero-bg"></div>
  <div class="hero-overlay"></div>

  <div class="hero-content">
    <h1 class="hero-title">
      Guincho <span>Anjo da Madrugada</span>
    </h1>

    <p class="hero-subtitle">
      Atendimento rápido 24 horas perto de você
    </p>

    <a class="btn b1"
      href="https://api.whatsapp.com/send?phone=5511933505696&text=Olá%20preciso%20de%20guincho%20agora"
      target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" class="bi bi-whatsapp">
          <g>
            <title>background</title>
            <rect x="-1" y="-1" width="34" height="34" id="canvas_background" fill="none" />
          </g>

          <g>
            <title>Layer 1</title>
            <path stroke="null"
              d="m26.945129,5.007134a15.24979,15.216487 0 0 0 -10.886882,-4.506436c-8.479225,0 -15.389589,6.893336 -15.397356,15.355982c0,2.710449 0.710647,5.347276 2.052334,7.681866l-2.1766,7.960854l8.162734,-2.135036a15.403181,15.369543 0 0 0 7.358888,1.869609l0.007767,0c8.481166,0 15.389589,-6.893336 15.397356,-15.363731a15.335223,15.301734 0 0 0 -4.520182,-10.863107l0.001942,0zm-10.886882,23.626822a12.762524,12.734654 0 0 1 -6.516208,-1.782425l-0.465998,-0.278988l-4.842497,1.267072l1.293145,-4.71374l-0.302899,-0.486292a12.737283,12.709467 0 0 1 -1.955251,-6.790653c0,-7.025081 5.741486,-12.755966 12.797474,-12.755966a12.737283,12.709467 0 0 1 9.048131,3.741156a12.731458,12.703655 0 0 1 3.743519,9.028372c-0.007767,7.050267 -5.749252,12.771465 -12.799416,12.771465zm7.019097,-9.559224c-0.382507,-0.191804 -2.271741,-1.119828 -2.627065,-1.251573c-0.353382,-0.125932 -0.611623,-0.191804 -0.864038,0.191804c-0.258241,0.381672 -0.996071,1.251573 -1.21742,1.5015c-0.221349,0.257677 -0.450465,0.286738 -0.834913,0.096871c-0.382507,-0.193742 -1.623227,-0.596725 -3.091121,-1.908358c-1.145579,-1.017145 -1.912534,-2.276467 -2.14165,-2.658139c-0.221349,-0.383609 -0.021358,-0.588975 0.170866,-0.78078c0.168924,-0.170493 0.382507,-0.449481 0.574731,-0.670347c0.194166,-0.220866 0.258241,-0.383609 0.384448,-0.639348c0.126208,-0.259614 0.066016,-0.48048 -0.029125,-0.672284c-0.097083,-0.191804 -0.864038,-2.084663 -1.188295,-2.848006c-0.310665,-0.753656 -0.627156,-0.649035 -0.864038,-0.658722c-0.221349,-0.013562 -0.47959,-0.013562 -0.73783,-0.013562a1.415469,1.412378 0 0 0 -1.027138,0.478542c-0.353382,0.383609 -1.341686,1.311633 -1.341686,3.204491c0,1.892858 1.378578,3.712094 1.572744,3.969771c0.190283,0.257677 2.706673,4.130577 6.568632,5.796757c0.91258,0.397171 1.630994,0.631599 2.192133,0.809841c0.922288,0.294488 1.75526,0.249927 2.419307,0.154994c0.73783,-0.11237 2.273683,-0.929961 2.59794,-1.826986c0.318432,-0.898962 0.318432,-1.66618 0.221349,-1.826986c-0.095141,-0.162743 -0.353382,-0.257677 -0.73783,-0.449481z"
              id="svg_1" fill="#fff" />
          </g>
        </svg> &nbsp;&nbsp;
      PRECISO DE GUINCHO AGORA
    </a>
  </div>
</section>
    <!-- HERO -->
    <section class="hero">

      <h1 class="hero-title">
        <strong class="title">Guincho Anjo da Madrugada</strong><br>
        <span class="hero-highlight">&nbsp; ATENDIMENTO 24 HORAS</span>
      </h1>

    </section>

    <!-- CTA WHATSAPP -->
    <section class="cta">

      <a class="btn b1"
        href="https://api.whatsapp.com/send?phone=5511933505696&text=Olá%20Anjo%20da%20Madrugada,%20Gostaria%20de%20solicitar%20um%20orçamento."
        target="_blank" rel="noopener noreferrer">

        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" class="bi bi-whatsapp">
          <g>
            <title>background</title>
            <rect x="-1" y="-1" width="34" height="34" id="canvas_background" fill="none" />
          </g>

          <g>
            <title>Layer 1</title>
            <path stroke="null"
              d="m26.945129,5.007134a15.24979,15.216487 0 0 0 -10.886882,-4.506436c-8.479225,0 -15.389589,6.893336 -15.397356,15.355982c0,2.710449 0.710647,5.347276 2.052334,7.681866l-2.1766,7.960854l8.162734,-2.135036a15.403181,15.369543 0 0 0 7.358888,1.869609l0.007767,0c8.481166,0 15.389589,-6.893336 15.397356,-15.363731a15.335223,15.301734 0 0 0 -4.520182,-10.863107l0.001942,0zm-10.886882,23.626822a12.762524,12.734654 0 0 1 -6.516208,-1.782425l-0.465998,-0.278988l-4.842497,1.267072l1.293145,-4.71374l-0.302899,-0.486292a12.737283,12.709467 0 0 1 -1.955251,-6.790653c0,-7.025081 5.741486,-12.755966 12.797474,-12.755966a12.737283,12.709467 0 0 1 9.048131,3.741156a12.731458,12.703655 0 0 1 3.743519,9.028372c-0.007767,7.050267 -5.749252,12.771465 -12.799416,12.771465zm7.019097,-9.559224c-0.382507,-0.191804 -2.271741,-1.119828 -2.627065,-1.251573c-0.353382,-0.125932 -0.611623,-0.191804 -0.864038,0.191804c-0.258241,0.381672 -0.996071,1.251573 -1.21742,1.5015c-0.221349,0.257677 -0.450465,0.286738 -0.834913,0.096871c-0.382507,-0.193742 -1.623227,-0.596725 -3.091121,-1.908358c-1.145579,-1.017145 -1.912534,-2.276467 -2.14165,-2.658139c-0.221349,-0.383609 -0.021358,-0.588975 0.170866,-0.78078c0.168924,-0.170493 0.382507,-0.449481 0.574731,-0.670347c0.194166,-0.220866 0.258241,-0.383609 0.384448,-0.639348c0.126208,-0.259614 0.066016,-0.48048 -0.029125,-0.672284c-0.097083,-0.191804 -0.864038,-2.084663 -1.188295,-2.848006c-0.310665,-0.753656 -0.627156,-0.649035 -0.864038,-0.658722c-0.221349,-0.013562 -0.47959,-0.013562 -0.73783,-0.013562a1.415469,1.412378 0 0 0 -1.027138,0.478542c-0.353382,0.383609 -1.341686,1.311633 -1.341686,3.204491c0,1.892858 1.378578,3.712094 1.572744,3.969771c0.190283,0.257677 2.706673,4.130577 6.568632,5.796757c0.91258,0.397171 1.630994,0.631599 2.192133,0.809841c0.922288,0.294488 1.75526,0.249927 2.419307,0.154994c0.73783,-0.11237 2.273683,-0.929961 2.59794,-1.826986c0.318432,-0.898962 0.318432,-1.66618 0.221349,-1.826986c-0.095141,-0.162743 -0.353382,-0.257677 -0.73783,-0.449481z"
              id="svg_1" fill="#fff" />
          </g>
        </svg> &nbsp;&nbsp;
        <span> CHAME O GUINCHO NO WHATSAPP</span>

      </a>

    </section>
  </div>
 <section class="hero">
  <div class="container">
     <div class="card-benefits">
      <div>
        <h1 class="title">
      Especialistas em <span class="highlight">Auto Socorro</span><br>
      <span style="font-weight: 100;font-style:normal; color: red;" class="">Reboque 24 Horas</span>
    </h1>

    <p class="subtitle">
      Estamos sempre perto de você. Atendimento imediato 24 horas.
    </p>
      <ul class="benefits">

      <li>
        <svg class="icon-check" viewBox="20 20 160 160" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 20c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80-35.82-80-80-80zm-9.761 113.896L63.124 107.6a2.001 2.001 0 0 1-.022-2.85l9.568-9.573a2 2 0 0 1 2.791-.037l14.776 14.01a2 2 0 0 0 2.808-.055l34.829-35.699a2 2 0 0 1 2.846-.018l9.547 9.547a2 2 0 0 1 .013 2.815l-47.22 48.12a2 2 0 0 1-2.821.036z"/>
        </svg>
        Carros, Motos, Veículos Leves e Pesados
      </li>

      <li>
        <svg class="icon-check" viewBox="20 20 160 160" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 20c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80-35.82-80-80-80zm-9.761 113.896L63.124 107.6a2.001 2.001 0 0 1-.022-2.85l9.568-9.573a2 2 0 0 1 2.791-.037l14.776 14.01a2 2 0 0 0 2.808-.055l34.829-35.699a2 2 0 0 1 2.846-.018l9.547 9.547a2 2 0 0 1 .013 2.815l-47.22 48.12a2 2 0 0 1-2.821.036z"/>
        </svg>
        Aceitamos e parcelamos no cartão
      </li>

      <li>
        <svg class="icon-check" viewBox="20 20 160 160" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 20c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80-35.82-80-80-80zm-9.761 113.896L63.124 107.6a2.001 2.001 0 0 1-.022-2.85l9.568-9.573a2 2 0 0 1 2.791-.037l14.776 14.01a2 2 0 0 0 2.808-.055l34.829-35.699a2 2 0 0 1 2.846-.018l9.547 9.547a2 2 0 0 1 .013 2.815l-47.22 48.12a2 2 0 0 1-2.821.036z"/>
        </svg>
        Recarga de Bateria (Pane Elétrica)
      </li>

      <li>
        <svg class="icon-check" viewBox="20 20 160 160" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 20c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80-35.82-80-80-80zm-9.761 113.896L63.124 107.6a2.001 2.001 0 0 1-.022-2.85l9.568-9.573a2 2 0 0 1 2.791-.037l14.776 14.01a2 2 0 0 0 2.808-.055l34.829-35.699a2 2 0 0 1 2.846-.018l9.547 9.547a2 2 0 0 1 .013 2.815l-47.22 48.12a2 2 0 0 1-2.821.036z"/>
        </svg>
        Atendimento 24h – 7 dias por semana
      </li>

    </ul>
    </div>
     <div> <img fetchpriority="high" sizes="680px"
      srcset="https://static.wixstatic.com/media/a4ed93_59690ae5be374d50a62eef9e5cb002a7~mv2.gif 1x, https://static.wixstatic.com/media/a4ed93_59690ae5be374d50a62eef9e5cb002a7~mv2.gif 2x"
      id="" src="https://static.wixstatic.com/media/a4ed93_59690ae5be374d50a62eef9e5cb002a7~mv2.gif"
      alt="" style="object-fit:cover" class="img" width="680" height="376"></div>
     </div>

  </div>
</section>
  <section class="services">
    <div class="service">
      <svg preserveAspectRatio="xMidYMid meet" data-bbox="32 10 135.999 180" viewBox="32 10 135.999 180" height="200"
        width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="presentation" aria-hidden="true"
        aria-label="">
        <g>
          <path
            d="M145.49 10h-27.106c-5.534 0-10.786 1.969-14.913 5.625L88.557 28.75c-2.72 2.438-6.284 3.75-9.942 3.75h-8.16c-.938 0-1.782.375-2.439 1.031l-8.348-8.344c-1.501-1.5-3.846-1.5-5.346 0L33.126 46.469c-1.501 1.5-1.501 3.844 0 5.344l9.004 9-.657.656c-.657.656-1.032 1.594-1.032 2.625V167.5c0 12.375 10.13 22.5 22.51 22.5h82.538c12.381 0 22.51-10.125 22.51-22.5v-135C168 20.125 157.87 10 145.49 10zm-4.033 140.697c1.501 1.5 1.501 3.844 0 5.344-.75.75-1.688 1.125-2.626 1.125s-1.876-.375-2.626-1.125l-31.89-31.875-31.89 31.875c-.75.75-1.688 1.125-2.626 1.125s-1.876-.375-2.626-1.125c-1.501-1.5-1.501-3.844 0-5.344l31.89-31.875-31.89-31.875c-1.501-1.5-1.501-3.844 0-5.344 1.501-1.5 3.846-1.5 5.346 0l31.89 31.875 31.89-31.875c1.501-1.5 3.846-1.5 5.346 0s1.501 3.844 0 5.344l-31.89 31.875 31.702 31.875zM145.583 32.5h-22.354c-1.797 0-3.454-1.192-3.824-2.95a3.761 3.761 0 0 1 3.668-4.55h22.371c1.819 0 3.653 1.453 3.862 3.259.279 2.401-1.505 4.241-3.723 4.241z"
            fill="#D81C1C" data-color="1"></path>
        </g>
      </svg>
      <h2>Pane Seca</h2>
      <p>Auto socorro para falta de combustível</p>
    </div>
    <div class="service">
      <svg preserveAspectRatio="xMidYMid meet" data-bbox="20 20 160 160" viewBox="20 20 160 160" height="200"
        width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="presentation" aria-hidden="true"
        aria-label="">
        <g>
          <path
            d="M100 44.233a2.913 2.913 0 0 0 2.913-2.913v-6.77a2.913 2.913 0 1 0-5.826 0v6.771A2.913 2.913 0 0 0 100 44.233z"
            fill="#D81C1C" data-color="1"></path>
          <path
            d="M100 155.767a2.913 2.913 0 0 0-2.913 2.913v6.77a2.913 2.913 0 1 0 5.826 0v-6.77a2.913 2.913 0 0 0-2.913-2.913z"
            fill="#D81C1C" data-color="1"></path>
          <path
            d="M44.233 100a2.913 2.913 0 0 0-2.913-2.913h-6.77a2.913 2.913 0 1 0 0 5.826h6.771A2.913 2.913 0 0 0 44.233 100z"
            fill="#D81C1C" data-color="1"></path>
          <path d="M165.45 97.087h-6.771a2.913 2.913 0 1 0 0 5.826h6.771a2.913 2.913 0 1 0 0-5.826z" fill="#D81C1C"
            data-color="1"></path>
          <path
            d="M69.797 41.862a2.913 2.913 0 0 0-5.045 2.913l3.385 5.863a2.91 2.91 0 0 0 3.979 1.066 2.913 2.913 0 0 0 1.066-3.979l-3.385-5.863z"
            fill="#D81C1C" data-color="1"></path>
          <path
            d="M131.862 149.362a2.913 2.913 0 0 0-5.045 2.913l3.385 5.863a2.91 2.91 0 0 0 3.979 1.066 2.913 2.913 0 0 0 1.066-3.979l-3.385-5.863z"
            fill="#D81C1C" data-color="1"></path>
          <path d="m47.726 126.817-5.863 3.385a2.913 2.913 0 0 0 2.913 5.045l5.863-3.385a2.913 2.913 0 0 0-2.913-5.045z"
            fill="#D81C1C" data-color="1"></path>
          <path
            d="M72.116 148.295a2.914 2.914 0 0 0-3.979 1.066l-3.385 5.863a2.913 2.913 0 0 0 5.045 2.913l3.385-5.863a2.913 2.913 0 0 0-1.066-3.979z"
            fill="#D81C1C" data-color="1"></path>
          <path
            d="m50.638 68.138-5.863-3.385a2.913 2.913 0 0 0-2.913 5.045l5.863 3.385a2.91 2.91 0 0 0 3.979-1.066 2.913 2.913 0 0 0-1.066-3.979z"
            fill="#D81C1C" data-color="1"></path>
          <path
            d="M126.422 51.705a2.908 2.908 0 0 0 3.979-1.066l3.385-5.863a2.913 2.913 0 0 0-5.045-2.913l-3.385 5.863a2.914 2.914 0 0 0 1.066 3.979z"
            fill="#D81C1C" data-color="1"></path>
          <path
            d="m150.813 73.183 5.863-3.385a2.913 2.913 0 0 0-2.913-5.045l-5.863 3.385a2.913 2.913 0 0 0 2.913 5.045z"
            fill="#D81C1C" data-color="1"></path>
          <path
            d="m158.137 130.202-5.863-3.385a2.913 2.913 0 0 0-2.913 5.045l5.863 3.385a2.91 2.91 0 0 0 3.979-1.066 2.912 2.912 0 0 0-1.066-3.979z"
            fill="#D81C1C" data-color="1"></path>
          <path
            d="M100 20c-44.112 0-80 35.888-80 80s35.887 80 80 80 80-35.888 80-80-35.888-80-80-80zm0 154.175c-40.9 0-74.175-33.275-74.175-74.174S59.1 25.825 100 25.825 174.175 59.1 174.175 100 140.9 174.175 100 174.175z"
            fill="#D81C1C" data-color="1"></path>
          <path
            d="M100 102.913h29.339a2.913 2.913 0 1 0 0-5.826h-27.658L80.427 60.275a2.913 2.913 0 0 0-5.045 2.913l22.095 38.269a2.914 2.914 0 0 0 2.523 1.456z"
            fill="#D81C1C" data-color="1"></path>
        </g>
      </svg>
      <h2>24 Horas</h2>
      <p>Auto socorro com atendimento 24 horas</p>
    </div>
    <div class="service">
      <svg preserveAspectRatio="xMidYMid meet" data-bbox="53.5 36.5 93 127" viewBox="53.5 36.5 93 127" height="200"
        width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="presentation" aria-hidden="true"
        aria-label="">
        <g>
          <path
            d="M99.999 163.5l-3.25-3.895C94.986 157.487 53.5 107.468 53.5 82.916 53.5 57.323 74.359 36.5 99.999 36.5c25.644 0 46.501 20.823 46.501 46.416 0 24.551-41.483 74.571-43.252 76.688l-3.249 3.896zm0-118.56c-20.978 0-38.046 17.036-38.046 37.977 0 16.359 25.019 51.015 38.046 67.305 13.029-16.29 38.048-50.946 38.048-67.305 0-20.942-17.068-37.977-38.048-37.977z"
            fill="#D81C1C" data-color="1"></path>
          <path
            d="M99.999 101.658c-10.351 0-18.775-8.407-18.775-18.741 0-10.335 8.424-18.743 18.775-18.743 10.353 0 18.777 8.408 18.777 18.743 0 10.333-8.424 18.741-18.777 18.741zm0-29.046c-5.69 0-10.32 4.621-10.32 10.304 0 5.68 4.63 10.303 10.32 10.303 5.692 0 10.324-4.622 10.324-10.303 0-5.682-4.632-10.304-10.324-10.304z"
            fill="#D81C1C" data-color="1"></path>
        </g>
      </svg>
      <h2>Atendimento</h2>
      <p>Atendemos em Grajaú e Região</p>
    </div>
  </section><br><br><br>
  <section >
      <a
        href="https://api.whatsapp.com/send?phone=5511933505696&text=Olá%20Anjo%20da%20Madrugada,%20Gostaria%20de%20solicitar%20um%20orçamento."
        target="_blank" class="btn b1"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
          class="bi bi-whatsapp">
          <g>
            <title>background</title>
            <rect x="-1" y="-1" width="34" height="34" id="canvas_background" fill="none" />
          </g>

          <g>
            <title>Layer 1</title>
            <path stroke="null"
              d="m26.945129,5.007134a15.24979,15.216487 0 0 0 -10.886882,-4.506436c-8.479225,0 -15.389589,6.893336 -15.397356,15.355982c0,2.710449 0.710647,5.347276 2.052334,7.681866l-2.1766,7.960854l8.162734,-2.135036a15.403181,15.369543 0 0 0 7.358888,1.869609l0.007767,0c8.481166,0 15.389589,-6.893336 15.397356,-15.363731a15.335223,15.301734 0 0 0 -4.520182,-10.863107l0.001942,0zm-10.886882,23.626822a12.762524,12.734654 0 0 1 -6.516208,-1.782425l-0.465998,-0.278988l-4.842497,1.267072l1.293145,-4.71374l-0.302899,-0.486292a12.737283,12.709467 0 0 1 -1.955251,-6.790653c0,-7.025081 5.741486,-12.755966 12.797474,-12.755966a12.737283,12.709467 0 0 1 9.048131,3.741156a12.731458,12.703655 0 0 1 3.743519,9.028372c-0.007767,7.050267 -5.749252,12.771465 -12.799416,12.771465zm7.019097,-9.559224c-0.382507,-0.191804 -2.271741,-1.119828 -2.627065,-1.251573c-0.353382,-0.125932 -0.611623,-0.191804 -0.864038,0.191804c-0.258241,0.381672 -0.996071,1.251573 -1.21742,1.5015c-0.221349,0.257677 -0.450465,0.286738 -0.834913,0.096871c-0.382507,-0.193742 -1.623227,-0.596725 -3.091121,-1.908358c-1.145579,-1.017145 -1.912534,-2.276467 -2.14165,-2.658139c-0.221349,-0.383609 -0.021358,-0.588975 0.170866,-0.78078c0.168924,-0.170493 0.382507,-0.449481 0.574731,-0.670347c0.194166,-0.220866 0.258241,-0.383609 0.384448,-0.639348c0.126208,-0.259614 0.066016,-0.48048 -0.029125,-0.672284c-0.097083,-0.191804 -0.864038,-2.084663 -1.188295,-2.848006c-0.310665,-0.753656 -0.627156,-0.649035 -0.864038,-0.658722c-0.221349,-0.013562 -0.47959,-0.013562 -0.73783,-0.013562a1.415469,1.412378 0 0 0 -1.027138,0.478542c-0.353382,0.383609 -1.341686,1.311633 -1.341686,3.204491c0,1.892858 1.378578,3.712094 1.572744,3.969771c0.190283,0.257677 2.706673,4.130577 6.568632,5.796757c0.91258,0.397171 1.630994,0.631599 2.192133,0.809841c0.922288,0.294488 1.75526,0.249927 2.419307,0.154994c0.73783,-0.11237 2.273683,-0.929961 2.59794,-1.826986c0.318432,-0.898962 0.318432,-1.66618 0.221349,-1.826986c-0.095141,-0.162743 -0.353382,-0.257677 -0.73783,-0.449481z"
              id="svg_1" fill="#fff" />
          </g>
        </svg> &nbsp;&nbsp;CHAME O GUINCHO NO WHATSAPP </a>
    </section>
  <section>
    <div> <a target="_blank"
        href="https://api.whatsapp.com/send?phone=5511933505696&amp;text=Olá%20Anjo%20da%20Madrugada,%20Gostaria%20de%20solicitar%20um%20orçamento."
        class="whatsapp-button"> <img src="@/assets/whatsapp-32.svg" alt="" width="32" height="32"> </a> </div>
    <br><br><br><br>
    <footer class="footer-section">
      <div class="row">
        <div>
          <h3>Sobre Nós</h3>
          <P>O <strong>Anjo da Madrugada</strong> Oferece serviço de guincho 24 horas, com atendimento rápido e seguro
            para motoristas que precisam de ajuda a qualquer momento. Trabalhamos com remoção de veículos leves e
            suporte emergencial, garantindo agilidade, responsabilidade e total cuidado no transporte do seu veículo.
          </P>
        </div>
        <div class="container">
          <h3>Informações Do Negócio</h3>
          <div class="contact-info">
            <a target="_blank"
              href="https://api.whatsapp.com/send?phone=5511933505696&amp;text=Olá%20Anjo%20da%20Madrugada,%20Gostaria%20de%20solicitar%20um%20orçamento."
              class="icon-text"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#D81C1C"
                class="bi bi-whatsapp" viewBox="0 0 16 16">
                <path
                  d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
              </svg>&nbsp; <span>(11) 9 3350-5696</span> </a>
            <a target="_blank" href="tel:11933505696" class="icon-text"><svg xmlns="http://www.w3.org/2000/svg"
                width="16" height="16" fill="#D81C1C" class="bi bi-telephone" viewBox="0 0 16 16">
                <path
                  d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
              </svg>&nbsp;<span>(11) 9 3350-5696</span></a>
          </div>
               <div class="contact-info"><img class="img-responsive" src="@/assets/ssl.webp" width="0" /></div>
        </div>
        <div>
              <section class="payment-section">

                <h1 class="payment-title">
                  Aceitamos todos os cartões e Pix.
                  <strong>Temos preços imbatíveis</strong>
                </h1>
                <img style="max-width: 90%!important;" src="@/assets/cartoes.webp" width="300" />
              </section>
            </div>
          </div>
          <div></div>
      <div class="copyright-area">
        <div>
          <p style="text-align: center">&copy; {{ new Date().getFullYear() }} - Todos os direitos reservados</p>
        </div>
      </div>
    </footer>
  </section>
</template>

<script>
// @ is an alias to /src
// //import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView'
  /*   components: {
      HelloWorld
    } */
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Teko:wght@300;400;500;600;700&display=swap');

/* HERO APP GRANDE */
.hero-app {
  position: relative;
  width: 100%;
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.hero-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url("@/assets/hero.avif");
  background-size: cover;
  background-position: center;
  transform: scale(1.1);
}

.hero-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  color: #fff;
  padding: 20px;
}

.hero-title {
  font-family: 'Teko', sans-serif;
  font-size: 70px;
  line-height: 1;
  margin-bottom: 10px;
}

.hero-title span {
  color: #ff2d2d;
}

.hero-subtitle {
  font-size: 20px;
  margin-bottom: 25px;
}

.hero-btn {
  font-size: 18px;
  padding: 18px 40px;
  border-radius: 50px;
}

/* MOBILE */
@media (max-width: 768px) {
  .hero-title {
    font-size: 42px;
  }

  .hero-app {
    height: 80vh;
  }
}
.img-responsive{
  width:100%;
  max-width:200px;
  height:auto;
}

body {
  *{
    overflow: hidden;
  }
  font-family: 'Montserrat', sans-serif;
}
.hero-title {
  display: block;
}
 .card-benefits{
 img{
  margin-top: 50px;
  width: 100%;
  min-width: 100%;
  height: auto;
}
min-width: 80vw!important;
  max-width: 80vw!important;
  margin: 100px 0;
  text-align: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 50px;
}
.benefits {
  list-style: none;
  padding: 0;
  margin: 0;
}

.benefits li {
  svg{
    margin: 8px;
  }
  padding: 2px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  font-size: 18px;
}

.services {
  display: inline-flex;
  gap: 12px;
}

.service {
  h2 {
    font-family: Teko, Sans-serif !important;
    color: #D81C1C
  }

  p {
    color: #fff;
  }

  max-width: 20vw;
  background: #000;
  border-radius: 32px;
  padding: 32px;
}

.icon-check {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  fill: #d81c1c;
  flex-shrink: 0;
}

@import url(https://fonts.googleapis.com/css2?family=Teko:wght@300..700&display=swap);
@import url(https://fonts.googleapis.com/css2?family=Kanit:wght@300;400;700&display=swap);

.title {
  color: #000 !important;
  font-family: Teko, Sans-serif !important;
  font-size: 50px;
  margin: 0;
  font-weight: 500;
  text-transform: uppercase;
  line-height: 58px;
  letter-spacing: -1.5px
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}

nav {
  padding: 30px
}

nav a {
  font-weight: 700;
  color: #2c3e50
}

nav a.router-link-exact-active {
  color: #42b983
}
.container{
   display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  ul {
    max-width: 50vw;
  }
}
.banner-container {
  overflow: hidden;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
  height: 150px;
  max-width: 150px;
  top: 0;
  right: 0
}

@media only screen and (max-width:600px) {
  .card-benefits{
    display: block;
    *:not(svg) {
  min-width: 80vw!important;
  max-width: 80vw!important
}
  }
  .services {
    display: block;
    gap: 0;
  }

  .service {
    margin-top: 10px;
    max-width: 80vw!important;
    min-width: 80vw !important;
  }

  .banner-container {
    right: -10px;
    top: -10px
  }
}

.rotate {
  animation: rotate-d4f03df2 10s linear infinite
}

@keyframes rotate-d4f03df2 {
  0% {
    transform: rotate(0deg)
  }

  to {
    transform: rotate(1turn)
  }
}

#circulo-banner:before {
  content: "";
  background-image: url(data:image/webp;base64,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);
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
  width: 50px;
  height: 50px;
  position: absolute;
  right: 0;
  left: 0;
  margin: 0 auto
}

text {
  font-size: 19px;
  font-weight: 700;
  text-transform: uppercase
}

* {
  overflow-x: hidden;
  text-decoration: none
}

@keyframes pulse-d4f03df2 {
  0% {
    transform: scaleX(1)
  }

  50% {
    transform: scale3d(1.05, 1.05, 1.05)
  }

  to {
    transform: scaleX(1)
  }
}

@keyframes pisca-d4f03df2 {
  70% {
    box-shadow: 0 0 0 25px transparent
  }

  to {
    box-shadow: 0 0 0 0 transparent
  }
}

.slides-container {
  border-top: 15px solid #ffc107;
  position: relative;
  max-width: 100vw;
  min-width: 100vw;
  left: 0 !important;
  height: 600px;
  overflow: hidden
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity .5s ease-in-out;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat
}

.slide[style*="display: block;"] {
  opacity: 1
}

.g4 {
  padding: 0 !important;
  margin: 0 auto !important;
  display: grid;
  max-width: 90% !important;
  grid-template-columns: repeat(4, 25%);
  -moz-column-gap: 5px;
  column-gap: 5px;
  row-gap: 2.5px
}

@media only screen and (max-width:600px) {
  .g4 {
    max-width: 100% !important;
    grid-template-columns: repeat(2, 50%)
  }
}

.g4 P {
  padding-right: 4px
}

.g4 img {
  max-width: 100% !important;
  min-width: 100% !important;
  width: auto;
  height: auto
}

.t {
  position: absolute;
  top: 5%;
  left: 6%;
  z-index: 10;
  max-width: 50vw !important;
  min-height: 100% !important
}

.t * {
  color: #212121 !important
}

@media only screen and (max-width:600px) {
  .t .title {
    font-size: 48px
  }

  .t {
    left: 5%;
    max-width: 90vw !important;
    min-height: 100% !important
  }
}

.font-hover {
  color: #fff !important;
  font-weight: 700;
  font-size: 2.5rem;
  text-transform: uppercase
}

.banner-contato {
  display: flex;
  flex-direction: column;
  gap: 16px
}

.banner-contato * {
  color: #fff !important
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 20px 30px;
  margin: 20px auto;
  border: none;
  border-radius: 36px;
  text-decoration: none;
  font-size: .9rem;
  font-weight: 600;
  max-width: 25vw !important;
  cursor: pointer
}

@media only screen and (max-width:600px) {
  .btn {
    max-width: 70vw !important;
    min-width: 70vw !important;
    font-size: .7rem
  }
}

.b1 {
  background: #00cf4b;
  box-shadow: 0 0 21px -6px #00cf4b
}

.b1,
.b2 {
  color: #fff;
  animation: pisca-d4f03df2 1.5s infinite
}

.b2 {
  background-color: #ab2424;
  box-shadow: 0 0 21px -6px #d32f2f
}

.icon32 {
  margin-right: 8px
}

.btn.b2:hover,
.btn:hover {
  background-color: #212121
}

.servicos {
  display: flex;
  flex-wrap: wrap
}

.servicos li {
  min-width: 45%
}

@media only screen and (max-width:600px) {
  .servicos li {
    min-width: 50%!important
  }
}

.footer-content {
  padding: 0 5px
}

.footer-content p {
  text-align: left !important
}

.icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 18px;
  margin-right: 5px;
  color: #d5d5d5;
  font-size: 10px;
  text-align: center;
  background-color: #f3f3f6;
  vertical-align: middle;
  border-radius: 50%
}

.row {
  display: flex;
  position: relative;
  width: 92vw;
  margin: 0 auto !important;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 6px
}

.row div {
  p {
    text-align: left;
  }

  width: calc(33.33333% - 4px)
}

@media only screen and (max-width:600px) {
  .row div {
    width: 95%
  }
}

* {
  overflow-x: hidden !important
}

h3 {
  font-family: Teko, Sans-serif;
  font-weight: 500;
  text-transform: uppercase;
  line-height: 58px;
  color: #212121
}

@media only screen and (max-width:600px) {
  h3 {
    font-size: 28px
  }
}

.footer-section {
  min-width: 100vw !important;
  max-width: 100vw !important;
  background: hsla(0, 0%, 48%, .09);
  color: #212121
}

.contact-info {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-width: 55%;
  margin: 0 auto !important
}

.contact-info .icon-text {
  color: #212121 !important
}

.copyright-area {
  padding: 15px 0;
  color: #212121;
  text-align: center
}

.copyright-area div {
  margin: 0 auto !important
}

.copyright {
  display: flex;
  justify-content: center
}

@media(max-width:767px) {
  .footer-menu {
    margin-top: 30px
  }
}

.whatsapp-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #00cf4b;
  width: 48px;
  height: 48px;
  padding: 20px;
  font-size: 16px;
  border-radius: 100%;
  text-decoration: none;
  animation: pulse-d4f03df2 4s infinite, pisca-d4f03df2 1.5s infinite;
  box-shadow: 0 0 21px -6px #25d366;
  transition: background-color .3s ease;
  position: fixed;
  bottom: 2vh;
  right: 5vw;
  z-index: 1000
}

.whatsapp-button:hover {
  background-color: #2aee72
}
</style>
